module.exports = __webpack_public_path__ + "img/logo.b310cac0.png";